import { Flex, Popconfirm, Popover } from 'antd';
import DownloadSolidW from '../../../assets/icons/download-solid-w.svg';
import TrashSolidB from '../../../assets/icons/trash-solid-b.svg';
import styles from './index.module.scss';
import { downloadFile } from '../../../helpers/File';
import { ColumnType } from 'antd/es/table';
import { AuthorizedIcon, Icon } from '../..';
import { IFile } from '../../../types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export const getColumns = (
  model: string,
  handleDeleteFile: (id: number, fileId: number) => Promise<void>,
): Array<ColumnType<IFile> & { searchable?: boolean }> => [
  {
    title: 'Dosya Adı',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name?.localeCompare(b.name),
    render: (_, record) => (
      <Popover content={record.name}>
        {record.name?.substring(0, 10) + '...'}
      </Popover>
    ),
  },
  {
    title: 'Eklenme Tarihi',
    dataIndex: 'uploaded_at',
    key: 'uploaded_at',
    sorter: (a, b) => a.uploaded_at?.localeCompare(b.uploaded_at),
    render: (_, record) => <div>{record.uploaded_at?.split('T')[0]}</div>,
  },
  {
    title: 'Kullanıcı',
    dataIndex: 'uploaded_by',
    key: 'uploaded_by',
    sorter: (a, b) => a.uploaded_by?.localeCompare(b.uploaded_by),
  },
  {
    title: 'Şirket',
    dataIndex: 'user_organization',
    key: 'user_organization',
    sorter: (a, b) => a.user_organization?.localeCompare(b.user_organization),
  },
  {
    title: 'İşlem',
    dataIndex: 'action',
    key: 'action',
    width: 150,
    render: (_: unknown, record: IFile) => {
      return (
        <Flex justify="flex-end" gap={14}>
          <Popconfirm
            title={
              <div className={styles.popconfirmTitle}>
                Ek dosyayı indirmek istiyor musunuz?
              </div>
            }
            overlayInnerStyle={{
              width: 150,
              borderColor: '#E59500',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
            okText="İndir"
            cancelText="İptal"
            icon={null}
            color="#FAFAFA"
            okButtonProps={{
              style: { backgroundColor: '#E59500', width: '45%' },
            }}
            cancelButtonProps={{
              style: { color: '#E59500', borderColor: '#E59500', width: '45%' },
            }}
            onConfirm={() => downloadFile(record.file)}
          >
            <Icon source={DownloadSolidW} />
          </Popconfirm>
          <Popconfirm
            title={
              <div className={styles.popconfirmTitle}>
                Ek dosyayı silmek istiyor musunuz?
              </div>
            }
            overlayInnerStyle={{
              width: 150,
              borderColor: '#D6222A',
              borderWidth: 1,
              borderStyle: 'solid',
            }}
            okText="Sil"
            cancelText="İptal"
            icon={null}
            color="#FAFAFA"
            okButtonProps={{
              style: { backgroundColor: '#D6222A', width: '45%' },
            }}
            cancelButtonProps={{
              style: { color: '#D6222A', borderColor: '#D6222A', width: '45%' },
            }}
            onConfirm={() => handleDeleteFile(record.policy, record.id)}
          >
            <AuthorizedIcon
              model={model}
              action="delete"
              source={TrashSolidB}
            />
          </Popconfirm>
        </Flex>
      );
    },
  },
];
